
























































































import Vue from 'vue'
import { IQuiz, IConfig, ICard, AppCard } from '../../interfaces/question'
import Idols from '../assets/data'
export default Vue.extend({
	name: 'Quiz',
	components: {},
	props: ['quiz', 'finishFunc'],
	data() {
		return {
			question: {} as IQuiz,
			cards: [] as AppCard[],
			songs: [] as any,
			idols: [] as any,
			thisIs: 1,
			answer: '',
			query: '',
			correct: {} as any,
			finalized: false,
		}
	},
	mounted: function () {
		this.getQuestion(true, true)
	},
	methods: {
		getQuestion: function (isNext: boolean, initial: boolean) {
			let thisIs = this.thisIs
			if (isNext) thisIs = thisIs + 1
			if (!isNext) thisIs = thisIs - 1
			if (initial) thisIs = 1
			const thisIsInternal = thisIs - 1
			this.thisIs = thisIs
			this.question = this.quiz[thisIsInternal] as IQuiz
			if (this.correct[this.question.uniqueId]) {
				this.answer = this.correct[this.question.uniqueId]
				this.query = this.correct[this.question.uniqueId]
			}
		},
		end: function () {
			this.finishFunc(this.correct)
		},
		toJaCardType: function (type: string | undefined) {
			if (type === 'all') return '全て'
			if (type === 'allSsr') return 'SSR(特訓前後)'
			if (type === 'ssr') return 'SSR(特訓前)'
			if (type === 'ssr+') return 'SSR+'
			if (type === 'sr') return 'SR(特訓前)'
			if (type === 'sr+') return 'SR+'
			if (type === 'r') return 'R(特訓前)'
			if (type === 'r+') return 'R+'
			if (type === 'n') return 'R(特訓前)'
			if (type === 'n+') return 'R+'
			return '一部'
		},
		saveAndQuestion: function (isNext: boolean, final?: boolean) {
			if (this.question.inputTypeRegExp && this.question.answerType === 'input') {
				if (!this.answer.match(new RegExp(this.question.inputTypeRegExp))) return alert(`入力値に誤りがあります。`)
			}
			if (!this.correct[this.question.uniqueId]) {
				this.correct[this.question.uniqueId] = this.answer
			} else {
				if (this.answer !== this.correct[this.question.uniqueId]) this.correct[this.question.uniqueId] = this.answer
			}
			this.answer = ''
			this.query = ''
			this.cards = []
			this.songs = []
			this.idols = []
			if (final) this.finalized = true
			else this.getQuestion(isNext, false)
		},
		select: function (title: string) {
			this.answer = title
		},
		songSearch: function () {
			const q = this.query
			const songsR = localStorage.getItem('songs')
			if (!songsR) return false
			const songs = JSON.parse(songsR) as any[]
			const songsF = songs.filter(function (a) {
				return a.name.toLowerCase().includes(q.toLowerCase())
			})
			this.songs = songsF
		},
		idolSearch: function () {
			const q = this.query
			const idolsF = Idols.filter(function (a) {
				return a.name.includes(q) || a.kana.includes(q)
			})
			this.idols = idolsF
		},
		cardSearch: function (config: IConfig) {
			const q = this.query
			const cardsR = localStorage.getItem('cards')
			if (!cardsR) return false
			const cards = JSON.parse(cardsR) as ICard[]
			const isAll = config.filter === 'all' || config.filter === 'allSsr'
			const isCompletelyPlus = config.filter.indexOf('+') > 0
			let cardsF = [] as AppCard[]
			let i = 0
			for (const c of cards) {
				if (!c.title?.includes(q) && !c.name_only?.includes(q)) continue
				const title = `${c.title ? `[${c.title}]` : ''}${c.name_only}`
				if (c.rarity_dep.rarity === 7) {
					if (config.filter !== 'all' && config.filter !== 'ssr' && config.filter !== 'ssr+' && config.filter !== 'allSsr') continue
				} else if (c.rarity_dep.rarity === 5) {
					if (config.filter !== 'all' && config.filter !== 'sr' && config.filter !== 'sr+') continue
				} else if (c.rarity_dep.rarity === 3) {
					if (config.filter !== 'all' && config.filter !== 'r' && config.filter !== 'r+') continue
				} else if (c.rarity_dep.rarity === 1) {
					if (config.filter !== 'all' && !config.filter.includes('n')) continue
				}
				if (isCompletelyPlus || isAll) {
					cardsF.push({
						id: c.evolution_id,
						title,
						plus: true,
					})
				}
				if (!isCompletelyPlus || isAll) {
					cardsF.push({
						id: c.id,
						title,
						plus: false,
					})
				}
				if (i > 50) break
				i++
			}
			this.cards = cardsF
		},
	},
})
